<template>
    <div style="width: 100%;padding: 20px;box-sizing: border-box;">
        <el-button size="small" type="primary" @click="editClub(null)" v-if="isStudentLogin() == false">New
            Club</el-button>

        <div class="club-grid">
            <club-card
                v-for="item in dataList"
                :key="item._id.$id"
                :club="item"
                :is-student="isStudentLogin()"
                :is-joined="false"
                @assign-advisor="doShowAssignAdvisorDialog"
                @view-detail="actionToClubDetail"
                @apply-join="applyJoinClub"
                @view-application="viewApplication"
            />
        </div>

        <el-dialog :visible.sync="showClubInfoDialog" :title="clubInfo.id == '' ? 'Add Club' : 'Edit Club'" width="45%">
            <div>
                <el-form :model="clubInfo" :rules="rules" ref="form" label-position="right" label-width="140px">
                    <el-form-item label="Club Name" prop="name">
                        <el-input v-model="clubInfo.name" style="width: 80%;"></el-input>
                    </el-form-item>
                    <el-form-item label="Club Type" prop="type">
                        <el-select v-model="clubInfo.type" placeholder="Please select">
                            <el-option v-for="type in club_type_list" 
                                     :key="type"
                                     :label="type" 
                                     :value="type">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Club Intro" prop="intro">
                        <el-input v-model="clubInfo.intro" type="textarea" :rows="4" style="width: 80%;"></el-input>
                    </el-form-item>
                </el-form>
                <div style="text-align: right;">
                    <el-button @click="showClubInfoDialog = false">Cancel</el-button>
                    <el-button type="primary" @click="saveClubInfo">Confirm</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="showAssignAdvisorDialog" title="Assign Advisers" width="70%">
            <div>
                <el-alert
                    title="Note: Advisory Class Year usually refers to the year when the advisory position is taken if tenure spans across years."
                    type="info"
                    :closable="false"
                    show-icon
                    style="margin-bottom: 20px;">
                </el-alert>

                <el-table :data="assignAdvisorInfo.advisors" style="width: 100%; margin-bottom: 20px;">
                    <el-table-column label="Adviser" min-width="200">
                        <template slot-scope="scope">
                            <el-select
                                v-model="scope.row.advisor_id"
                                placeholder="Select adviser"
                                :filterable="true"
                                style="width: 100%">
                                <el-option
                                    v-for="(contact, index) in contact_list"
                                    :key="index"
                                    :value="contact.contact_info._id.$id"
                                    :label="contact.contact_info.contact_givenName + ' ' + contact.contact_info.contact_lastName"
                                    :disabled="isAdvisorAlreadySelected(contact.contact_info._id.$id, scope.$index)">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>

                    <el-table-column label="Tenure Start" min-width="150">
                        <template slot-scope="scope">
                            <el-date-picker
                                v-model="scope.row.tenure_start"
                                type="date"
                                placeholder="Start date"
                                value-format="yyyy-MM-dd"
                                size="small"
                                style="width: 100%">
                            </el-date-picker>
                        </template>
                    </el-table-column>

                    <el-table-column label="Tenure End" min-width="150">
                        <template slot-scope="scope">
                            <el-date-picker
                                v-model="scope.row.tenure_end"
                                type="date"
                                placeholder="End date"
                                value-format="yyyy-MM-dd"
                                size="small"
                                style="width: 100%">
                            </el-date-picker>
                        </template>
                    </el-table-column>

                    <el-table-column label="Advisory Class Year" min-width="140">
                        <template slot-scope="scope">
                            <el-select
                                v-model="scope.row.advisory_class"
                                placeholder="Year"
                                clearable
                                size="small"
                                style="width: 100%">
                                <el-option
                                    v-for="year in classYearOptions"
                                    :key="year"
                                    :label="year"
                                    :value="year">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>

                    <el-table-column label="Actions" width="100">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                @click="removeAdvisorRow(scope.$index)"
                                style="color: #F56C6C;">
                                Delete
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div style="margin-bottom: 20px;">
                    <el-button type="text" icon="el-icon-plus" @click="addAdvisorRow">Add Adviser</el-button>
                </div>

                <div style="text-align: right;">
                    <el-button @click="showAssignAdvisorDialog = false">Cancel</el-button>
                    <el-button type="primary" @click="saveClubAssignedAdvisor">Confirm</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import ClubCard from '@/components/ClubCard.vue'
import {
    getStudentAccountClubs,
    assignedToAdvisor,
    getContactsByAccount,
    getSchoolAdminClubs,
    updateClub
} from '../../api/eclub'
import {
    getUserType,
    getUserId
} from '../../utils/store'
export default ({
    name: 'index',
    components: {
        ClubCard
    },
    data() {
        return {
            user_type: getUserType(),
            user_id: getUserId(),
            dataList: [],
            clubInfo: {
                id: '',
                name: '',
                intro: '',
                type: '',
                creator_id: '',
                creator_type: getUserType()
            },
            rules: {
                name: [
                    { required: true, message: 'Please input', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: 'Please select', trigger: 'blur' }
                ],
                intro: [
                    { required: true, message: 'Please input', trigger: 'blur' }
                ],
            },
            showClubInfoDialog: false,
            contact_list: [],
            showAssignAdvisorDialog: false,
            assignAdvisorInfo: {
                club_id: '',
                advisors: []
            },
            classYearOptions: this.generateClassYearOptions(),
            club_type_list: [
                'Academic',
                'Arts',
                'Business & Finance',
                'Community Service & Volunteering', 
                'Culture & Diversity',
                'Environmental & Sustainability',
                'Health & Wellness',
                'Leadership',
                'Literature & Language',
                'Media & Journalism',
                'Music & Dance & Performing Arts',
                'Social Science',
                'Sports',
                'STEM',
                'Student Governance',
                'Technology & Engineering',
                'Vocation and Career',
                'Others',
            ]
        }
    },
    mounted() {
        this.fetchData()
        this.requestContacts()
    },
    methods: {
        actionToClubDetail (data) {
            this.$router.push({
                name: 'Club Detail',
                query: {
                    club_id: data._id.$id,
                }
            })
            console.log(data)

        },
        gotClubStudents(row) {
            this.$router.push({
                path: '/home/clubstudents',
                query: {
                    club_id: row._id.$id
                }
            })
        },

        tableCellstyle() {
            return 'background:  #FAE3E4;border:1px solid white;text-align:center; font-family: GravityBold;'
        },

        isStudentLogin() {
            return getUserType() == 'student'
        },

        requestContacts() {
            getContactsByAccount(this.user_id).then((res) => {
                this.contact_list = res.data.data
            })
        },

        fetchData() {
            if (this.isStudentLogin()) {
                getStudentAccountClubs(this.user_id).then((res) => {
                    this.dataList = res.data.data
                })
                return
            }
            getSchoolAdminClubs(this.user_id).then((res) => {
                this.dataList = res.data.data
            })
        },
        editClub(raw) {
            if (raw) {
                this.clubInfo = {
                    id: raw._id.$id,
                    name: raw.name,
                    intro: raw.intro,
                    creator_id: raw.creator_id,
                    type: raw.type,
                    creator_type: raw.creator_type
                }
            } else {
                this.clubInfo = {
                    id: '',
                    name: '',
                    intro: '',
                    creator_id: this.user_id,
                    type: '',
                    creator_type: getUserType()
                }
            }
            this.showClubInfoDialog = true
        },
        saveClubInfo() {
            this.$refs.form.validate((val) => {
                if (val) {
                    updateClub(this.clubInfo).then((res) => {
                        this.$message.success('Update successful')
                        this.fetchData()
                        this.showClubInfoDialog = false
                    })
                }
            })

        },
        generateClassYearOptions() {
            const currentYear = new Date().getFullYear()
            const years = []
            for (let i = 3; i >= -3; i--) {
                years.push(String(currentYear + i))
            }
            return years
        },
        doShowAssignAdvisorDialog(row) {
            this.assignAdvisorInfo.club_id = row._id.$id
            // Convert existing advisor assignments to new format
            if (row.advisor_assignments && row.advisor_assignments.length > 0) {
                this.assignAdvisorInfo.advisors = row.advisor_assignments.map(a => ({
                    advisor_id: a.advisor_id,
                    tenure_start: a.tenure_start || '',
                    tenure_end: a.tenure_end || '',
                    advisory_class: a.advisory_class || ''
                }))
            } else if (row.assigned_user_ids && row.assigned_user_ids.length > 0) {
                // Backward compatibility: convert old format
                this.assignAdvisorInfo.advisors = row.assigned_user_ids.map(id => ({
                    advisor_id: id,
                    tenure_start: '',
                    tenure_end: '',
                    advisory_class: ''
                }))
            } else {
                this.assignAdvisorInfo.advisors = []
            }
            this.showAssignAdvisorDialog = true
        },
        addAdvisorRow() {
            this.assignAdvisorInfo.advisors.push({
                advisor_id: '',
                tenure_start: '',
                tenure_end: '',
                advisory_class: ''
            })
        },
        removeAdvisorRow(index) {
            this.assignAdvisorInfo.advisors.splice(index, 1)
        },
        isAdvisorAlreadySelected(advisorId, currentIndex) {
            return this.assignAdvisorInfo.advisors.some((a, idx) =>
                idx !== currentIndex && a.advisor_id === advisorId
            )
        },
        saveClubAssignedAdvisor() {
            // Filter out rows without advisor_id
            const validAdvisors = this.assignAdvisorInfo.advisors.filter(a => a.advisor_id)
            assignedToAdvisor(this.assignAdvisorInfo.club_id, validAdvisors).then((res) => {
                this.$message.success('Advisers Updated Successfully.')
                this.fetchData()
                this.showAssignAdvisorDialog = false
            })
        },
        applyJoinClub(club) {
            this.$router.push({
                name: 'Club Application',
                query: { 
                    club_id: club._id.$id,
                    club_name: club.name,
                    club_type: club.type
                }
            })
        },
        viewApplication(club) {
            this.$router.push({
                name: 'Club Application',
                query: {
                    club_id: club._id.$id,
                    club_name: club.name
                }
            })
        }
    }
})
</script>
<style scoped lang="scss">
.club-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 20px;
}
</style>